module.exports = __webpack_public_path__ + "static/img/qj.9feccaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qj.jpg
// module id = 4chX
// module chunks = 1